<script setup lang="ts">
import { useArtifactStore } from '@/store/artifacts'

const props = defineProps(nodeViewProps)
const { t } = useI18n()
import { NodeViewWrapper, nodeViewProps } from '@tiptap/vue-3'
import { computed, ComputedRef, onMounted, Ref, ref } from 'vue'
import CustomNodeEditMenu from '@/components/wysiwyg-components/nodes/CustomNodeEditMenu.vue'
import { useI18n } from 'vue-i18n'
import { humanReadableTimestamp } from '@/composables/datetime'
import GenericCustomDialog from '@/components/GenericCustomDialog.vue'
import ArtifactDisplay from '@/components/artifacts/ArtifactDisplay.vue'
import { Artifact } from '@/types/Artifact'

const chipText: ComputedRef<string> = computed(() => {
  if (!artifact.value) return t('artifacts.unknown')
  return `${t(`filters.artifacts.properties.type.options.${artifact.value.type}.title`)} (${humanReadableTimestamp(artifact.value.timestamp)})`
})
const artifactId = props.node.attrs.artifactId
const artifactStore = useArtifactStore()
const artifact: Ref<Artifact | null> = ref(null)
onMounted(async () => {
  if (artifactId) {
    artifact.value = await artifactStore.loadArtifactData(artifactId)
  }
})
</script>

<template>
  <node-view-wrapper
    as="div"
    class="d-inline-block"
  >
    <CustomNodeEditMenu
      :selected="props.selected"
      :variant-parameters="node.attrs"
      current-variant="inline-artifact"
      :variants="[
        { tag: 'inline-artifact', label: 'Inline', icon: 'mdi-text' },
        { tag: 'artifact-card', label: 'Card', icon: 'mdi-card-text' },
      ]"
      :node-props="props"
      :editor-focused="props.editor.isFocused"
    >
      <template #element="nodeProps">
        <v-chip
          color="primary"
          append-icon="mdi-chevron-right"
          :v-bind="nodeProps"
        >
          {{ chipText }}
          <GenericCustomDialog activator="parent">
            <template #body><ArtifactDisplay :artifact-id="artifactId"></ArtifactDisplay></template>
          </GenericCustomDialog>
        </v-chip>
      </template>
    </CustomNodeEditMenu>
  </node-view-wrapper>
</template>

<style scoped></style>
